import isEqual from 'lodash/isEqual';
import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

function useDeepCompareMemoize(value: any) {
  const ref = useRef();

  if (!isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}

export const useDeepEffect = (callback: EffectCallback, deps: DependencyList) => {
  useEffect(callback, deps.map(useDeepCompareMemoize));
};
